import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ElectricalSidebar from './ElectricalSidebar';
import power1 from '../../img/Power Factor/power1.jpg'
import power2 from '../../img/Power Factor/power2.jpg'

function PowerDistribution() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <section className="py-5 bg-light mt-5" id="power-distribution-transformer">
      <div className="container">
        <div className="row">
          {/* Main Content */}
          <div className="col-lg-9 col-md-8 mb-4">
            {/* Title */}
            <div className="text-center mb-4" data-aos="fade-up">
              <h2 className="fw-bold">🔌 POWER & DISTRIBUTION TRANSFORMER</h2>
              <p className="text-muted">
                Power and distribution transformers are used to step up or step-down voltage levels in electrical networks. They are essential in power transmission, distribution substations, industrial plants, commercial buildings, and renewable energy systems to ensure efficient and reliable energy flow.
              </p>
            </div>

            <div className="row mb-4" data-aos="zoom-in">
              <div className="col-md-6 mb-3">
                <img
                  src={power1}
                  alt="MCC Panel"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="col-md-6 mb-3">
                <img
                  src={power2}
                  alt="Motor Control Center"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
                />
              </div>
            </div>

            {/* Ratings */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-primary">📏 Ratings</h4>
              <ul className="text-muted">
                <li><strong>Voltage Class:</strong> Up to 33kV (Distribution), up to 132kV (Power)</li>
                <li><strong>Capacity Range:</strong> 25 kVA to 10 MVA (Distribution); above 10 MVA for Power</li>
                <li><strong>Frequency:</strong> 50/60 Hz</li>
                <li><strong>Cooling Type:</strong> ONAN / ONAF / AN / AF</li>
                <li><strong>Vector Group:</strong> Dyn11, Yyn0, others as per application</li>
              </ul>
            </div>

            {/* IEC Standards */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-info">📘 IEC Standards</h4>
              <ul className="text-muted">
                <li>IEC 60076 Series – Power Transformers</li>
              </ul>
            </div>

            {/* Key Features */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-success">✨ Key Features</h4>
              <ul className="text-muted">
                <li>Voltage Ratings: 11kV and 33kV</li>
                <li>Capacity: Up to 20 MVA</li>
                <li>Type: Oil-immersed, copper-wound</li>
                <li>ONAN/ONAF cooling options</li>
                <li>Optional OLTC (On Load Tap Changer) or manual tap changer</li>
                <li>BIS/IEC certified with robust thermal and dielectric performance</li>
              </ul>
            </div>

            {/* Call to Action */}
            <div
              className="p-4 bg-white border-start border-4 border-primary rounded shadow-sm"
              data-aos="fade-up"
            >
              <h5 className="text-dark fw-semibold">Need Power & Distribution Transformers?</h5>
              <p className="mb-2 text-muted">
                We provide custom transformer solutions tailored to your power distribution needs.
              </p>
              <a
                href="/contact"
                className="btn"
                style={{
                  backgroundColor: '#08717A',
                  color: '#fff',
                  border: 'none',
                }}
              >
                Contact Us
              </a>
            </div>
          </div>

          {/* Sidebar */}
          <ElectricalSidebar />
        </div>
      </div>
    </section>
  );
}

export default PowerDistribution;
